import React, { useState } from "react";
import { HelpCircle, X } from "lucide-react";

const HelpButton = () => {
  const [showHelp, setShowHelp] = useState(false);

  const toggleHelp = () => {
    setShowHelp(!showHelp);
  };

  return (
    <>
      <button
        className="help-button insights-help-button"
        onClick={toggleHelp}
        aria-label="Help"
      >
        <HelpCircle size={20} />
      </button>

      {showHelp && (
        <div className="help-overlay">
          <div className="help-content">
            <button className="close-help" onClick={toggleHelp}>
              <X size={20} />
            </button>
            <h3>Value Insights</h3>
            <div className="help-section">
              <h4>What is Value Insights?</h4>
              <p>
                Value Insights is a tool for discovering undervalued stocks and
                analyzing investment opportunities based on intrinsic value
                metrics. It helps you find stocks trading at a discount to their
                estimated fair value.
              </p>
            </div>

            <div className="help-section">
              <h4>API Usage Limitations</h4>
              <p>
                This feature uses financial data APIs with limited daily calls.
                To make the most of your usage:
              </p>
              <ul>
                <li>Use specific filters to narrow down your search</li>
                <li>Start with a smaller number of stocks to analyze</li>
                <li>Data is cached once loaded to minimize API usage</li>
                <li>
                  Use the search function to find specific stocks rather than
                  browsing all
                </li>
              </ul>
            </div>

            <div className="help-section">
              <h4>Using Filters Effectively</h4>
              <p>
                The more specific your filter criteria, the faster and more
                efficient your search:
              </p>
              <ul>
                <li>Set a meaningful discount range for intrinsic value</li>
                <li>Filter by sector to focus on industries you understand</li>
                <li>Use ROIC and margin filters to find quality companies</li>
                <li>
                  Adjust the number of stocks to parse based on your needs
                </li>
              </ul>
            </div>

            <div className="help-section">
              <h4>Pro Tips</h4>
              <p>For the best experience:</p>
              <ul>
                <li>
                  Start with preset filters to see common value strategies
                </li>
                <li>Use the search box to quickly find specific companies</li>
                <li>Click on any stock to see detailed analysis</li>
                <li>
                  Select a small number of stocks for more detailed analysis
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HelpButton;
